






































import {
  Component,
  Emit,
  Mixins,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import PretensionHttpErrorMixin from '@/mixins/PretensionHttpErrorMixin';
import PretensionController from '@/controllers/Pretension';
import { describeOperationError } from '@/utils/extractApiErrorMessage';

@Component
export default class RejectByControllerModal extends Mixins(
  validationMixin,
  PretensionHttpErrorMixin,
) {
  @Prop({ required: true }) pretensionId!: number;

  @Prop({ default: false }) value!: boolean;

  private comment = '';

  private isSendingRequest = false;

  @Validations()
  validations() {
    return {
      comment: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(2000),
      },
    };
  }

  get commentErrors(): string[] {
    const v = this.$v.comment as any;
    if (!v || !v.$dirty) return [];
    const errors: string[] = [];
    if (v.required === false) errors.push('Комментарий обязателен');
    if (v.minLength === false) errors.push('Слишком короткий комментарий');
    if (v.maxLength === false) errors.push('Максимум 2000 символов');
    return errors;
  }

  @Emit('input') emitInput(_open: boolean): void { /* noop */ }

  @Emit('success') emitSuccess(): void { /* noop */ }

  @Emit('stale-state') emitStaleState(): void { /* noop */ }

  @Watch('value')
  onValueChanged(open: boolean): void {
    if (open) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          window.setTimeout(() => {
            const ref = this.$refs.commentInput as { focus?: () => void } | undefined;
            if (ref && ref.focus) {
              ref.focus();
            }
          }, 200);
        });
      });
    } else {
      this.comment = '';
      this.$v.$reset();
    }
  }

  async onSubmit(): Promise<void> {
    this.$v.$touch();
    if (this.$v.$invalid) return;

    this.isSendingRequest = true;
    try {
      const response = await PretensionController.controlReject(this.pretensionId, this.comment);
      if (response.result[0]) {
        const outcome = this.classifyHttpError(response);
        this.$bus.$emit('notification', outcome.message, outcome.type);
        if (outcome.isStaleState) {
          this.emitStaleState();
          this.closeAndReset();
        }
        return;
      }
      this.$bus.$emit('notification', 'Претензия возвращена HR', 'success');
      this.emitSuccess();
      this.closeAndReset();
    } catch (error) {
      this.$bus.$emit('notification', `Возникла ошибка: ${describeOperationError(error)}`, 'error');
    } finally {
      this.isSendingRequest = false;
    }
  }

  private closeAndReset(): void {
    this.emitInput(false);
    this.comment = '';
    this.$v.$reset();
  }
}
